import { useCallback } from 'react';
import { type Location, useLocation, useNavigate } from 'react-router';

type LocationState = {
  redirectPath?: string;
};

export const useGoBack = (forceRedirectPath?: string) => {
  const location: Location<LocationState> = useLocation();
  const navigate = useNavigate();

  return useCallback(() => {
    if (location.state?.redirectPath) {
      const { redirectPath, ...state } = location.state;
      navigate(redirectPath, { state });

      return;
    }

    if (forceRedirectPath) {
      navigate(forceRedirectPath);
      return;
    }

    navigate(-1);
  }, [forceRedirectPath, location.state, navigate]);
};
